/**
 * Search bar dropdown JS
 */

// Wait for the DOM to be fully loaded before executing any script
document.addEventListener('DOMContentLoaded', () => {
  /**
   * Function to toggle the search bar's visibility by toggling a CSS class
   */
  function toggleSearchBar() {
    const searchDropdown = document.getElementById('search-dropdown');

    if (searchDropdown) {
      searchDropdown.classList.toggle('search-dropdown--active');
    }
  }

  const searchToggle = document.getElementById('toggle-search');

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      toggleSearchBar();
    });
  }

  const cancelSearch = document.getElementById('search-cancel');

  if (cancelSearch) {
    cancelSearch.addEventListener('click', () => {
      toggleSearchBar();
    });
  }
});
